<template>
    <div class="grid font-bold text-sm grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
        <p>Tipologia</p>
        <p>Allegato</p>
        <p></p>
        <p></p>
    </div>

    <div v-for="(file, i) in files" :key="i" class="grid grid-cols-[repeat(3,_minmax(0,_1fr))_max-content] gap-4 mb-3">
        <div class="flex flex-col">
            <Field :label-visible="false" v-model="file.id" placeholder="Tipologia"
                   :errors="getErrors(i,'type')">
                <Select v-model="file.type" :options="selectOptions"></Select>
            </Field>
        </div>
        <div class="flex flex-col col-span-2 ">
            <Field :label-visible="false" v-model="file.name" placeholder="Name"
                   :errors="getErrors(i,'file_id')"
            >
                <SingleFileUpload
                    v-model:file="file.file"
                    accept=".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx">
                    <template v-slot:default="{props, methods}">
                        <div class="grid grid-cols-2 gap-3">
                            <div class="flex items-center underline text-sm bg-next-gray-md-dark px-3">
                                <a class="underline text-next-atp break-words cursor-pointer"
                                v-show="file?.file?.id" @click="downloadFile(file?.file?.id)">
                                    <span><i class="icon icon-graffetta"></i> {{ file?.file?.name }}</span>
                                </a>
                                <span v-show="!file?.file?.id">Vuoto</span>
                            </div>
                            <NextButton variant="outline-secondary" @click="methods.open"
                                        class="w-full h-10 px-4 col-start-2">
                                <i class="icon icon-graffetta"></i> {{ file?.file? 'Cambia' : 'Allega'}}
                            </NextButton>
                        </div>
                    </template>
                </SingleFileUpload>
            </Field>
        </div>
        <div class="flex items-center">
            <NextButton variant="outline-secondary" @click="remove(i)"
                        class="col flex justify-center items-center h-8 w-8"><i class="icon-x"></i></NextButton>
        </div>
    </div>

    <div class="flex justify-end">

        <NextButton variant="primary" @click="add"
                    class="col flex justify-center items-center h-8 w-8"><i class="icon-croce_quadrata"></i>
        </NextButton>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Select from "@/components/Select.vue";
import SingleFileUpload from "@/components/SingleFileUpload.vue";
import FileUpload from "@/components/FileUpload.vue";

@Options({
    name: 'AllegatiUploader',
    components: {FileUpload, SingleFileUpload, Select, NextButton, Field},
    inject: ['downloadFile'],
    props: {
        files: Array,
        errors: {
            type: Object,
            default: {}
        }
    }
})
export default class AllegatiUploader extends Vue {
    files!: any[]
    errors!: any

    selectOptions = [
        {id: -1, text: 'Listino'},
        {id: -2, text: 'Presentazione'},
        {id: -3, text: 'Altro'},
    ]

    remove(idx: number) {
        this.files.splice(idx, 1)
        this.$emit('update:files', this.files)
    }

    add() {
        this.$emit('update:files', [...this.files, {file: null, type: -1}])
    }

    getErrors(index: string | number, field: string) {
        return (this.errors as any)[`allegati.${index}.${field}`]
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
